<template>
  <div class="page-container">
    <van-nav-bar
      left-arrow
      fixed
      :z-index="10"
      @click-left="goableBack()"
      :title="itemObj.noticeTypeName"></van-nav-bar>
    <div class="container">
      <div class="content-title">{{ itemObj.title }}</div>
      <div class="content-date">
        {{ itemObj.releaseTime }}
      </div>
      <div class="content" v-html="itemObj.content"></div>
    </div>
  </div>
</template>

<script>
import { getNoticeContent } from "@/api/notice"
export default {
  data() {
    return {
      itemObj: {}
    }
  },
  beforeMount() {
    const id = this.$route.params.id
    // this._showLoading()
    getNoticeContent(id)
      .then((data) => {
        // this._dismissLoading()
        if (!data) return
        this.itemObj = data
      })
      .catch((e) => {
        // this._dismissLoading()
        this.$toast(e.msg || e.message)
      })
  }
}
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 15px;

  .content-title {
    font-size: 16px;
    font-weight: 600;

    //   text-align:center;
  }
  .content-date {
    //  text-align:center;
    color: @gray-dark;
  }
  .content {
    overflow: hidden;
    ::v-deep img {
      width: 100%;
    }
  }
}
</style>
